const Lemo_Modal = {
    backdrop: true,
    buttons: {},
    content: null,
    id: 'modal',
    keyboard: true,
    size: null,
    title: null,
    attrClass: '',

    /**
     * Prida tlacitko do modalniho okna
     *
     * @param {string} id
     * @param {string} label
     * @param {string} classs
     * @param {function} callback
     */
    addButton: function (id, label, classs, callback) {
        this.buttons[id] = {};
        this.buttons[id].label = label;
        this.buttons[id].classs = classs;
        this.buttons[id].callback = callback;

        return this;
    },

    /**
     * Sestaveni modalniho okna
     *
     * @returns {boolean}
     */
    build: function (callback) {
        var modalSelector = '#' + this.id;
        var modalContainer = $(modalSelector);
        if (modalContainer.length) {
            this.reset();
            return this;
        }

        // Velikost
        var size = '';
        if ('large' === this.size) {
            size = ' modal-lg';
        }
        if ('small' === this.size) {
            size = ' modal-sm';
        }

        var html = $('<div id="' + this.id + '" class="modal fade ' + this.attrClass + '"></div>');
        var htmlModalDialog = $('<div class="modal-dialog' + size + '"></div>');
        var htmlModalContent = $('<div class="modal-content"></div>');
        var htmlModalHeader = $('<div class="modal-header"></div>');
        var htmlModalBody = $('<div class="modal-body" id="dialogBody"></div>');
        var htmlModalFooter = $('<div class="modal-footer" id="dialogButtons"></div>');

        // Hlavicka
        if ('' != this.title) {
            if (typeof Lemo_Translate.string === 'function') {
                this.title = Lemo_Translate.string(this.title);
            }

            htmlModalHeader.append('<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>');
            htmlModalHeader.append('<h4 class="modal-title">' + this.title + '</h4>');

            htmlModalContent.append(htmlModalHeader);
        }

        if ('' != this.content) {
            htmlModalBody.html(this.content);
        }

        // Obsah
        htmlModalContent.append(htmlModalBody);

        // Paticka
        if (typeof this.buttons != 'undefined') {
            $.each(this.buttons, function (i, attribs) {
                if (typeof Lemo_Translate.string === 'function') {
                    attribs.label = Lemo_Translate.string(attribs.label);
                }

                var button = $('<button>' + attribs.label + '</button>')
                    .attr('class', ('' === attribs.classs) ? 'btn' : attribs.classs)
                    .on('click.lemocore.modal', attribs.callback);

                htmlModalFooter.append(button);
            });

            htmlModalContent.append(htmlModalFooter);
        }

        htmlModalDialog.append(htmlModalContent);
        html.append(htmlModalDialog);

        $('body').append(html);

        var modalLast = $(modalSelector).last();

        $(modalLast).modal({
            'backdrop': this.backdrop,
            'keyboard': this.keyboard
        });

        // Zavreni krizkem
        $(modalLast).find('.modal-header > .close').on('click.lemocore.modal', function (e) {
            e.preventDefault();
            Lemo_Modal.close();
        });

        // Zavreni modal ESC
        var keyboard = this.keyboard;
        $(document)
            .off('keydown.lemocore.modal')
            .on('keydown.lemocore.modal', function (e) {
                var code = e.keyCode ? e.keyCode : e.which;
                if (code == 27 && true == keyboard) {
                    e.preventDefault();
                    Lemo_Modal.close();
                }
            });

        this.enableSubmitOnEnter();
        this.reset();

        // Callback
        if (callback && typeof(callback) === 'function') {
            callback();
        }

        return this;
    },

    enableSubmitOnEnter: function () {
        $('.modal')
            .last()
            .off('keydown.lemocore.modal', ':input')
            .on('keydown.lemocore.modal', ':input:not(textarea)', function (e) {
                var code = e.keyCode ? e.keyCode : e.which;
                if (13 === code) {
                    e.preventDefault();

                    return false;

                    // var button = $('.modal').find('.modal-footer > button').eq(0);
                    // if (button.length && 'disabled' != button.attr('disabled')) {
                    //     Lemo_Modal.disableSubmitOnEnter();
                    //     button.trigger('click');
                    //     button.attr('disabled', true);
                    //     button.prop('disabled', true);
                    // }
                    // return false;
                }
                return true;
            });

        return this;
    },

    disableSubmitOnEnter: function () {
        $('.modal')
            .last()
            .off('keydown.lemocore.modal', ':input')
            .off('keypress', ':input')
            .off('keyup', ':input');

        return this;
    },

    /**
     * Vyresetuje hodnoty modalniho okna
     */
    reset: function () {
        this.buttons = {};
        this.content = null;
        this.id = 'modal';
        this.title = null;
        return this;
    },

    /**
     * Zavre posledni modalni okno
     */
    close: function () {
        $('.modal')
            .last()
            .one('hidden.bs.modal', function (e) {
                e.preventDefault();
                $(this).remove();

                // Odstraneni .lemocore.modal eventu pri uzavreni posledniho okna
                var modalContainer = $(document).find('.modal');
                if (!modalContainer.length) {
                    $(document).off('.lemocore.modal');
                }
            })
            .modal('hide');

        // Odstrani pripadny iframe
        var iframe = $('#uploadiframe');
        if (iframe.length) {
            iframe.remove();
        }

        return this;
    },

    /**
     * Ma se okno zavrit pri stiku na pozadi?
     *
     * @param backdrop
     */
    setBackdrop: function (backdrop) {
        this.backdrop = backdrop;
        return this;
    },

    /**
     * Ma se okno zavrit pri stiku klavesy ESC?
     *
     * @param keyboard
     */
    setKeyboard: function (keyboard) {
        this.keyboard = keyboard;
        return this;
    },

    /**
     * Pridani tridy k modalnimu oknu
     *
     * @param attrClass
     */
    setClass: function (attrClass) {
        this.attrClass = attrClass;
        return this;
    },

    /**
     * Nastavi obsah modalniho okna
     *
     * @param content
     */
    setContent: function (content) {
        this.content = content;
        return this;
    },

    /**
     * Nastavi ID modalniho okna
     *
     * @param id
     */
    setId: function (id) {
        this.id = id;
        return this;
    },

    /**
     * Nastavi velikost modalniho okna
     *
     * @param size
     */
    setSize: function (size) {
        if ('large' === size || 'small' === size) {
            this.size = size;
        } else {
            console.log("Unsupported modal size. Supported is only 'large' or 'small'");
        }
        return this;
    },

    /**
     * Nastavi nadpis modalniho okna
     *
     * @param title
     */
    setTitle: function (title) {
        this.title = title;
        return this;
    }
}

window.Lemo_Modal || (window.Lemo_Modal = Lemo_Modal);
